import cn from 'classnames';
import DOMPurify, { type Config } from 'dompurify';
import { FC, useMemo } from 'react';

const DEFAULT_CONFIG: Config = {};

export type SanitizeHtmlProps = {
  html: string | null | undefined;
  className?: string;
  config?: Config;
};

export const SanitizeHtml: FC<SanitizeHtmlProps> = ({ html, className, config = DEFAULT_CONFIG }) => {
  const sanitized = useMemo(() => {
    if (html == null || typeof html !== 'string') return '';
    const trimmed = html.trim();
    if (!trimmed) return '';
    return DOMPurify.sanitize(trimmed, config);
  }, [html, config]);

  if (!sanitized) return null;

  return (
    <div
      className={cn(className)}
      // eslint-disable-next-line react/no-danger -- контент проходит через DOMPurify.sanitize
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};
